<div class="lob-model-view ownership-management-block">
    <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
        <div class="uitk-c-card uhc-font">
            <div class="uitk_new_header">
                <div class="uitk-l-grid__col--12 stk-container-tabl-header">
                    <div class="stk-header-action ">
                        <div class="table-header-icons row">
                            <ng-container>
                                <div class="table-search col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-6">
                                    <mat-form-field class="data-filter" appearance="outline" style="padding: 0px;">
                                        <input [(ngModel)]="searchField" matInput type="text" class="role-search"
                                            placeholder="Search Segment/User"
                                            (keyup)="searchDataSet()">
                                        <img src="../../../../assets/images/searchicon.png"
                                            class="role-view-search-img" />
                                    </mat-form-field>
                                </div>
                            </ng-container>
                            <div class="table-header-icons table-header-icons-buttons col-md-8 col-sm-6 col-lg-8 col-xl-8 col-xs-6 ">
                                <div (click)="exportToExcel()" class="export-link d-inline m-2 pull-right">
                                    <span title="Click to Download"
                                        class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"></span>
                                </div>
                                <!-- <button *ngIf="isForecastAdmin" (click)="AddNewEntry()"
                                    class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs pull-right">Add</button> -->
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uitk-c-card__content" style="margin-top: 0px !important;">
                <div class="stk-table-container role-table-loader">
                    <div class="stk-table-loader" *ngIf="showLoader">
                        <app-loader>
                        </app-loader>
                    </div>
                    <ng-container *ngIf="!showLoader">
                        <app-maintenance-table-v4 [TABLE_CONFIG]="TABLE_CONFIG" [COLUMNS]="TABLE_COLUMNS"
                        [SORT_CONFIG]="sortConfig" [dataSource]="dataSourceDetails" [SCHEMA]="DATA_SCHEMA"
                        [pageSize]="TABLE_CONFIG.pageSize"
                        [pageIndex]="TABLE_CONFIG.pageIndex" 
                        [pageSizeOptions]="[10,20,30]"
                        [isResetFilter]="isResetFilter"
                        (editEvent)="onEditClick($event)">
                    </app-maintenance-table-v4>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #addEditRoleManagement class="add-edit-forecast-role-management" (closeModal)="clearData()">
    <ng-container class="app-modal-header">{{actionType == 'Edit' ? 'Edit Role' : 'Add Role'}}</ng-container>
    <ng-container class="app-modal-body " *ngIf="showModal">
      <app-add-edit-forecast-role-management [allForecastRoleData]="oldDataSource" [editData]="editData" [actionType]="actionType" [segmentData]="segmentData" (refreshParentTable)="refreshTable()"></app-add-edit-forecast-role-management>
    </ng-container>
</app-modal>